import { Component, OnInit } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { Estimator } from 'src/app/core/interfaces/calendar/estimator';
import { ApiService } from 'src/app/core/services/api/api.service';
import { DataService } from 'src/app/core/services/data/data.service';

@Component({
  selector: 'app-estimator-calendar-select',
  templateUrl: './estimator-calendar-select.component.html',
  styleUrls: ['./estimator-calendar-select.component.scss'],
})
export class EstimatorCalendarSelectComponent implements OnInit {
  estimators: Estimator[] = [];
  selectedEstimator: string;

  constructor(private data: DataService, private apiService: ApiService) {}

  ngOnInit(): void {
    this.apiService.getEstimators().subscribe((estimators) => {
      this.estimators = estimators;
    });
  }

  selectEstimator(event: MatSelectChange) {
    this.data.changeEstimator(event.value);
  }

  ngOnDestroy(): void {
    this.data.changeEstimator(null);
  }
}
